import { SubscriptionTier } from 'app/dataStore/types';
import React from 'react';

import { Typography } from '@material-ui/core';

export interface SubTierLabelProps {
  subTier: SubscriptionTier | undefined;
}

export const SubTierLabel: React.FC<SubTierLabelProps> = React.memo(props => {
  if(!props.subTier){
    return <></>;
  }

  return <Typography variant='body1' id='userSubTier' data-value={props.subTier.id} style={{lineHeight: '32px'}}>{props.subTier.name}</Typography>
});